import script from "./CurrencySelect.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrencySelect.vue?vue&type=script&setup=true&lang=js"

import "./CurrencySelect.vue?vue&type=style&index=0&id=3b9f242a&lang=css"

const __exports__ = script;

export default __exports__